<app-bringoz-state-link [state]="'logistics-vehicle.vehicle-profile'"
                        [permission]="'vehicleInstance.logisticsVehicle.get'"
                        [params]="{id: id}"
                        [text]="name"
                        [ngbTooltip]="name">

</app-bringoz-state-link>


<!--<div layout="row" class="full-height">-->
<!--  <a class="md-accent md-hue-1 br-link-1 text-ellipsis"-->
<!--     style="display: block"-->
<!--     ng-click="$event.stopPropagation();"-->
<!--     ng-disabled="!$ctrl.id"-->
<!--     ui-sref="logistics-vehicle.vehicle-profile({id:$ctrl.id})">-->
<!--    {{$ctrl.name}}-->
<!--  </a>-->
<!--  <md-tooltip ng-if="$ctrl.showTooltip" md-direction="top" md-delay="300" class="bringoz-tooltip">-->
<!--    <span>{{$ctrl.name}}</span>-->
<!--  </md-tooltip>-->
<!--</div>-->
